import { formatDistanceToNow, parseISO } from 'date-fns';

export const formatDateToTimeAgo = (dateString: Date | string): string => {
  const date = parseISO(dateString as string);
  const fullDistance = formatDistanceToNow(date);

  return fullDistance
    .replace(/years?/, 'y')
    .replace(/months?/, 'mo')
    .replace(/weeks?/, 'w')
    .replace(/days?/, 'd')
    .replace(/hours?/, 'h')
    .replace(/minutes?/, 'm')
    .replace(/seconds?/, 's')
    .replace('about ', '')
    .replace('less than ', '')
    .replace('almost ', '')
    .replace('over ', '')
    .replace('a ', '1 ')
    .replace('an ', '1 ');
};
